export const heroPhotos = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hx2rvrR4PRf8RS6piGv56W/IMG_0552.png',
    alt: 'Біла сорочка та спідниця міді з еко шкіри',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/u89SjeDznUbTPLwgH7UiWq/IMG_0577.png',
    alt: 'Сірі широкі штани з в’язаною накидкою',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vVPUmYaMqHC7vx1P77w8T6/photo_5382105999629558304_y.jpg',
    alt: 'Біла атласна сорочка та бежеві штани кльош',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/q9LrwZ6K7C1N8YCPjmmh8c/photo_5382105999629558305_y.jpg',
    alt: 'Шоколадна атласна сорочка та світлі штани',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hHRva8A35kBo6XHqBhsZew/photo_5382105999629558330_y.jpg',
    alt: 'Корсет з еко шкіри з ґудзиками',
  },
]
